import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/gooseLogo.png"; // adjust path to your logo
import { useTranslation } from "react-i18next";

function Header({ changeLanguage }) {
    const { t, i18n } = useTranslation();
  return (
    <header>
      <div className="btm-header header-without-login pt-3 pb-3">
        <div className="container">
          <div className="inner_header d-flex flex-wrap align-items-center justify-content-between">
            {/* Logo */}
            <div className="logo-sec d-flex justify-content-between align-items-center gap-2">
              <div className="inner-btm-header d-flex align-items-center justify-content-between">
                <div className="logo_header">
                  <Link to="/">
                    <img src={logo} alt="Logo" />
                  </Link>
                </div>
              </div>

              {/* Offcanvas Menu */}
              <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
                <div className="offcanvas-body">
                  <div className="main-menu">
                    <div className="center-top-menu">
                      <ul className="top-head-menu d-flex flex-wrap align-items-center unorderlist">
                        <li>
                          <Link to="/" className="active">{t("Home")}</Link>
                        </li>
                        <li>
                          <Link to="/trip">{t("Trip")}</Link>
                        </li>
                        <li>
                          <Link to="/deals">{t("Deals")}</Link>
                        </li>
                        <li>
                          <Link to="/contact-us">{t("Contact Us")}</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side Buttons */}
            <div className="btn-box-header-right d-flex align-items-center gap-3">
              {/* Profile Dropdown */}
              <div className="position-relative dropdown">
                <button className="btn btn-primary btn-header rounded-pill" data-bs-toggle="dropdown" aria-expanded="false">
                 {t("My Profile")}
                </button>

                <div className="dropdown-menu p-2 mt-0 menu-profile-btn-box">
                  <ul className="list-unstyled p-0 m-0">
                    <li>
                     <Link to="/" className="d-flex align-items-center gap-2" data-bs-toggle="modal" data-bs-target="#exampleModal1">
                        <span className="icons">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="50px"><path d="M16.5 6a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M18 6A6 6 0 1 0 6 6a6 6 0 0 0 12 0M3 23.25a9 9 0 1 1 18 0 .75.75 0 0 0 1.5 0c0-5.799-4.701-10.5-10.5-10.5S1.5 17.451 1.5 23.25a.75.75 0 0 0 1.5 0"></path></svg>
                        </span>
                        <span className="text">{t("ChangePassword")}</span>
                      </Link>
                    </li>

                    <li>
                      <Link to="mybooking.html" className="d-flex align-items-center gap-2">
                        <span className="icons">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="50px"><path d="M22.5 14.249v4.5a2.25 2.25 0 0 1-2.25 2.25H3.75a2.25 2.25 0 0 1-2.25-2.25v-9a2.25 2.25 0 0 1 2.25-2.25h16.5a2.25 2.25 0 0 1 2.25 2.25zm1.5 0v-4.5a3.75 3.75 0 0 0-3.75-3.75H3.75A3.75 3.75 0 0 0 0 9.749v9a3.75 3.75 0 0 0 3.75 3.75h16.5a3.75 3.75 0 0 0 3.75-3.75zm-18-7.5v15a.75.75 0 0 0 1.5 0v-15a.75.75 0 0 0-1.5 0m10.5 0v15a.75.75 0 0 0 1.5 0v-15a.75.75 0 0 0-1.5 0m0 0v-3a2.25 2.25 0 0 0-2.25-2.25h-4.5a2.25 2.25 0 0 0-2.25 2.25v3a.75.75 0 0 0 1.5 0v-3a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v3a.75.75 0 0 0 1.5 0"></path></svg>
                        </span>
                        <span className="text">{t("Bookings&Trips")}</span>
                      </Link>
                    </li>

                    <li>
                      <Link to="/sign-in" className="d-flex align-items-center gap-2">
                        <span className="icons">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" width="50px"><path d="m1.19 66.83 20 20a4.002 4.002 0 1 0 5.66-5.66L13.67 68H88a4 4 0 0 0 0-8H13.67l13.18-13.17a4.002 4.002 0 1 0-5.66-5.66l-20 20q-.275.28-.5.6s0 .11-.08.16a3 3 0 0 0-.28.53 2 2 0 0 0-.08.24 3 3 0 0 0-.15.51 3.9 3.9 0 0 0 0 1.58q.054.261.15.51.033.122.08.24.115.274.28.52c0 .06.05.11.08.16q.225.325.5.61m31.13 35c20.876 19.722 53.787 18.787 73.509-2.089 14.874-15.743 18.432-39.058 8.931-58.521-10.77-22.12-42-37.41-69.52-24a52 52 0 0 0-12.91 8.93 4.004 4.004 0 0 1-5.49-5.83 60 60 0 0 1 14.9-10.29C67.26-2.37 106.48 6 122 37.74c14.519 29.787 2.142 65.704-27.645 80.223-22.44 10.938-49.308 6.839-67.465-10.293a4 4 0 0 1 5.48-5.82z"></path></svg>
                        </span>
                        <span className="text">{t("Sign Out")}</span>
                      </Link>
                    </li>

                    {/* Select Options */}
                    <li>
                      <div className="profile-settings">
                        {/* Region Selector */}
                        <div className="select-box">
                          <label htmlFor="region">{t("Select Region")}</label>
                          <select id="region" className="form-select">
                            <option value="">{t("Choose Region")}</option>
                            <option value="us">{t("United States")}</option>
                            <option value="uae">{t("United Arab Emirates")}</option>
                          </select>
                        </div>

                        {/* Currency Selector */}
                        <div className="select-box">
                          <label htmlFor="currency">{t("Select Currency")}</label>
                          <select id="currency" className="form-select">
                            <option value="">{t("Choose Currency")}</option>
                            <option value="usd">{t("$ USD")}</option>
                            <option value="aed">{t("AED - UAE Dirham")}</option>
                          </select>
                        </div>

                        {/* Language Selector */}
                        <div className="select-box">
                          <label htmlFor="language">{t("Select Language")}</label>
                          <select id="language" className="form-select" onChange={(e) => changeLanguage(e.target.value)}>
                            <option value="en">English</option>
                            <option value="ar">Arabic</option>
                          </select>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Mobile Hamburger Menu */}
              <div className="btn-menu-mobile">
                <button className="btn btn-menu border-0" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                  <i className="fas fa-bars"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
